import Collapsible from '../plugins/collapsiblePlugin';

export default function initCollapsible() {
  document.querySelectorAll('.nav-menu li').forEach((item) => {
    if (item.querySelector(':scope > ul') || item.querySelector(':scope > div')) {
      new Collapsible({
        wrap: '.menubar',
        holder: item,
        opener: '> a',
        slide: '.sub-menu-holder',
        btnBack: '.sub-menu-back a',
      });
    }
  });

  const navLinks = document.querySelectorAll('.nav-menu a');
  navLinks.forEach((link) => {
    link.addEventListener('opener-clicked', function (e) {
      const firstLink = e.detail.holder.querySelector('li.show-sub-menu > a');
      if (e.detail.isOpened) {
        firstLink.dispatchEvent(new CustomEvent('show-sub-menu'));
      } else {
        firstLink.dispatchEvent(new CustomEvent('hide-sub-menu'));
      }
    });
  });

  const links = document.querySelectorAll('.nav-menu li.show-sub-menu a');
  links.forEach((link) => {
    if (link.nextElementSibling && link.nextElementSibling.classList.contains('sub-menu-holder')) {
      ['show-sub-menu', 'click'].forEach((event) => {
        link.addEventListener(event, function (e) {
          if (window.innerWidth >= 1024 && window.innerWidth < 1280) {
            document.querySelectorAll('.sub-menu-opened').forEach((item) => {
              item.classList.remove('sub-menu-opened');
            });
            link.parentElement.classList.add('sub-menu-opened');
          }
        });
      });
      link.addEventListener('hide-sub-menu', function (e) {
        if (window.innerWidth >= 1024 && window.innerWidth < 1280) {
          document.querySelectorAll('.sub-menu-opened').forEach((item) => {
            item.classList.remove('sub-menu-opened');
          });
        }
      });
    }
  });
}
